const Languages=[
    { label: 'Auto Detect', value: 'auto' },
    { label: 'Arabic (Egypt)', value: 'ar-eg' },
    { label: 'Bulgarian (Bulgaria)', value: 'bg-bg' },
    { label: 'Chinese (Simplified, China)', value: 'zh-cn' },
    { label: 'Chinese (Traditional, Taiwan)', value: 'zh-tw' },
    { label: 'Croatian (Croatia)', value: 'hr-hr' },
    { label: 'Czech (Czech Republic)', value: 'cs-cz' },
    { label: 'Danish (Denmark)', value: 'da-dk' },
    { label: 'Dutch (Netherlands)', value: 'nl-nl' },
    { label: 'English (United States)', value: 'en-us' },
    { label: 'Farsi (Iran)', value: 'fa-ir' },
    { label: 'Finnish (Finland)', value: 'fi-fi' },
    { label: 'French (France)', value: 'fr-fr' },
    { label: 'German (Germany)', value: 'de-de' },
    { label: 'Greek (Greece)', value: 'el-gr' },
    { label: 'Hebrew (Israel)', value: 'he-il' },
    { label: 'Hindi (India)', value: 'hi-in' },
    { label: 'Hungarian (Hungary)', value: 'hu-hu' },
    { label: 'Indonesian (Indonesia)', value: 'id-id' },
    { label: 'Italian (Italy)', value: 'it-it' },
    { label: 'Japanese (Japan)', value: 'ja-jp' },
    { label: 'Klingon (Qo’noS)', value: 'tlh' },
    { label: 'Korean (Korea)', value: 'ko-kr' },
    { label: 'Lithuanian (Lithuania)', value: 'lt-lt' },
    { label: 'Malay (Malaysia)', value: 'ms-my' },
    { label: 'Norwegian Bokmål (Norway)', value: 'nb-no' },
    { label: 'Polish (Poland)', value: 'pl-pl' },
    { label: 'Portuguese (Brazil)', value: 'pt-br' },
    { label: 'Romanian (Romania)', value: 'ro-ro' },
    { label: 'Russian (Russia)', value: 'ru-ru' },
    { label: 'Serbian (Bosnia and Herzegovina)', value: 'sr-ba' },
    { label: 'Slovak (Slovakia)', value: 'sk-sk' },
    { label: 'Slovenian (Slovenia)', value: 'sl-si' },
    { label: 'Spanish (Spain)', value: 'es-es' },
    { label: 'Swedish (Sweden)', value: 'sv-se' },
    { label: 'Tagalog (Philippines)', value: 'tl-ph' },
    { label: 'Thai (Thailand)', value: 'th-th' },
    { label: 'Turkish (Turkey)', value: 'tr-tr' },
    { label: 'Ukrainian (Ukraine)', value: 'uk-ua' },
    { label: 'Vietnamese (Vietnam)', value: 'vi-vn' }
  ];
  

export default Languages;